<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="40%"
    class="agreeDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="agreeDialogForm" :rules="rules" label-width="180px" :model="formData">
      <el-row>
        <el-col :span="24" v-if="directorsShow">
          <el-form-item :label="$t('approvalCenter.EventManager')" prop="directors">
            <el-select
              v-model="formData.directors"
              filterable
              multiple
              remote
              reserve-keyword
              :key="$t('general.peak')"
              :remote-method="remoteMethod"
              :loading="directorsLoading"
            >
              <el-option v-for="item in directorsList" :key="item.userId" :label="item.userName" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('approvalCenter.AppCom')">
            <el-input type="textarea" v-model="formData.reason" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCloseHandle">{{$t('btn.Cancel')}}</el-button>
      <el-button type="primary" @click="subBtn">{{$t('btn.OK')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { newApplicationFormApi } from '@/views/newApplicationForm/service';

export default {
  data () {
    return {
      rules: {
        directors: [
          { required: true, message: this.$t('approvalCenter.Psaem'), trigger: 'blur' }
        ],
        reason: [
          { required: true, message: this.$t('approvalCenter.Peac'), trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      formData: {},
      directorsList: [],
      directorsLoading: false,
      directorsShow: false
    };
  },
  props: {
    echoData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    agreeDialogVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: '同意'
    },
    approved: {
      type: String,
      default: ''
    }
  },
  watch: {
    agreeDialogVisible (val) {
      if (val) {
        if (this.dialogTitle === this.$t('btn.Agree')) {
          this.$set(this.formData, 'reason', this.$t('btn.Agree'));
        }
        if (this.dialogTitle === this.$t('btn.Rejected')) {
          this.$set(this.formData, 'reason', this.$t('btn.Rejected'));
        }
        let activityClassificationCode = this.echoData.marketActivity.activityClassificationCode;
        // 如果活动分类选择总部重点活动||总部一般活动，则显示活动负责人选项
        if ((activityClassificationCode === 'AC_06') && this.approved.indexOf('活动经理') !== -1) {
          this.directorsShow = true;
        }
      } else {
        this.formData = {};
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.directorsLoading = true;
        newApplicationFormApi.getChargeman(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.directorsList = res.data;
            } else {
              this.directorsList = [];
            }
          }
          this.directorsLoading = false;
        });
      } else {
        this.directorsList = [];
      }
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    subBtn () {
      this.$refs['agreeDialogForm'].validate((valid) => {
        if (valid) {
          this.$emit('agreeSubHandle', this.formData);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.agreeDialog{
}
</style>
